import { CertificationConfirmDialog } from "@modules/certificaciones/shared/ui";

type Props = {
  open: boolean;
  title: string;
  description: string;
  confirming?: boolean;
  confirmLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export function Iso2700127701ConfirmDialog(props: Props) {
  return <CertificationConfirmDialog {...props} eyebrow="ISO 27001-27701" />;
}
